import { BrowserRouter as Router, Route, Routes } from "react-router-dom"
import { AdminLayout } from "@/layouts/admin-layout"
import { ProtectedRoute } from "@/components/protected-route"
import Dashboard from "./pages/Dashboard"
import CompanyExpenses from "./pages/CompanyExpenses"
import ExpenseDetail from "./pages/ExpenseDetail"
import PersonalExpenses from "./pages/PersonalExpenses"
import PersonalExpenseDetail from "./pages/PersonalExpenseDetail"
import Profile from "./pages/Profile"
import Workers from "./pages/Workers"
import WorkerDetail from "./pages/WorkerDetail"
import Customers from "./pages/Customers"
import CustomerDetail from "./pages/CustomerDetail"
import Materials from "./pages/Materials"
import MaterialIncomes from "./pages/MaterialIncomes"
import Orders from "./pages/Orders"
import OrderDetail from "./pages/OrderDetail"
import Pricing from "./pages/Pricing"
import Products from "./pages/Products"
import Sell from "./pages/Sell"
import AvailableProducts from "./pages/AvailableProducts"
import LoginPage from "./pages/Login"
import UnauthorizedPage from "./pages/Unauthorized"
import "./index.css"

export function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/unauthorized" element={<UnauthorizedPage />} />
        <Route path="/available-products" element={<AvailableProducts />} />
        <Route
          element={
            <ProtectedRoute allowedRoles={["admin"]}>
              <AdminLayout />
            </ProtectedRoute>
          }
        >
          <Route path="/" element={<Dashboard />} />
          <Route path="/company-expenses" element={<CompanyExpenses />} />
          <Route path="/company-expenses/:id" element={<ExpenseDetail />} />
          <Route path="/personal-expenses" element={<PersonalExpenses />} />
          <Route path="/personal-expenses/:id" element={<PersonalExpenseDetail />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/workers" element={<Workers />} />
          <Route path="/workers/:id" element={<WorkerDetail />} />
          <Route path="/customers" element={<Customers />} />
          <Route path="/customers/:id" element={<CustomerDetail />} />
          <Route path="/materials" element={<Materials />} />
          <Route path="/material-incomes" element={<MaterialIncomes />} />
          <Route path="/orders" element={<Orders />} />
          <Route path="/orders/:id" element={<OrderDetail />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/products" element={<Products />} />
          <Route path="/sell" element={<Sell />} />
        </Route>
      </Routes>
    </Router>
  )
}

export default App
